import React from "react";
import ReactDOM from "react-dom";
// WORDPRESS components
import { withNotices } from "@wordpress/components";
import * as wpUrl from "@wordpress/url";
// THIRD PARTY modules
import "normalize.css";
import "../../node_modules/@wordpress/components/build-style/style.css";

// LOCAL components
import Dashboard from "./Dashboard";
/**
 * Determines if _ is lodash or not
 */
 import _ from 'lodash';
 export const isLodash = () => {
  let isLodash = false;

  // If _ is defined and the function _.forEach exists then we know underscore OR lodash are in place
  if ( 'undefined' != typeof( _ ) && 'function' == typeof( _.forEach ) ) {

      // A small sample of some of the functions that exist in lodash but not underscore
      const funcs = [ 'get', 'set', 'at', 'cloneDeep' ];

      // Simplest if assume exists to start
      isLodash  = true;

      funcs.forEach( function ( func ) {
          // If just one of the functions do not exist, then not lodash
          isLodash = ( 'function' != typeof( _[ func ] ) ) ? false : isLodash;
      } );
  }

  if ( isLodash ) {
      // We know that lodash is loaded in the _ variable
      return true;
  } else {
      // We know that lodash is NOT loaded
      return false;
  }
};


// console.log("IS LOADASH!", _.noConflict);
/**
 * Address conflicts
 */
 if ( isLodash() ) {
  // console.log("IS LOADASH!")
  _.noConflict();
}

// CONSTANTS
const queryArgs = wpUrl.getQueryArgs(window.location.href);
let updatedWidgetMeta = {};

const DashboardWithNotices = withNotices(({ noticeOperations, noticeUI }) => {
  const notify = ({ content, status }) => noticeOperations.createNotice({ content, status });
  return (
    <div>
      {noticeUI}
      <Dashboard
        notify={notify}
        widgetMeta={updatedWidgetMeta}
        step={queryArgs.step}
      />
    </div>
  );
});

async function mountComponent() {
  updatedWidgetMeta = await window.Widgetic.api('widgets/' + CONFIG.widgetId);
  global[CONFIG.widgetId] = {};
  global[CONFIG.widgetId].blockSlug = updatedWidgetMeta.slug;
  global[CONFIG.widgetId].blockPageStr = updatedWidgetMeta.name.toLowerCase().replace(' ', '_');
  // console.log("Dashboard index blockSlug:", global[CONFIG.widgetId].blockSlug);
  const rootElement = document.getElementById("dashboard-el-" + CONFIG.widgetId);
  if (rootElement) {
    ReactDOM.render(<DashboardWithNotices />, rootElement);
  }
}

// start Dashboard by mounting the root element
mountComponent();


